/**
 * Baghdad landing page (SEO-ready template)
 * - Generates meta + FAQ + LocalBusiness JSON-LD for Baghdad landing.
 * - Template only; routing not modified here.
 */

import React from 'react'
import Seo from '../../components/Seo'
import FAQList from '../../components/faq/FAQList'

/**
 * Baghdad landing page component
 */
export default function BaghdadLanding(): JSX.Element {
  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'Does Edicoo serve clients in Baghdad?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Yes — Edicoo delivers media planning, digital advertising and influencer campaigns across Baghdad and central Iraq.'
        }
      },
      {
        '@type': 'Question',
        name: 'Can Edicoo provide on-ground production in Baghdad?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Yes — we partner with local production teams and talent to execute shoots and activations in Baghdad.'
        }
      }
    ]
  }

  const localBusinessJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'ProfessionalService',
    name: 'Edicoo Agency — Baghdad (service area)',
    url: 'https://your-site.com/landings/baghdad',
    telephone: '+964 750 413 2323',
    areaServed: 'Baghdad, Iraq',
    sameAs: [
      'https://www.linkedin.com/company/edicoo',
      'https://www.facebook.com/edicoo',
      'https://www.instagram.com/edicoo'
    ]
  }

  const faqItems = (faqJsonLd.mainEntity || []).map((m: any) => ({
    question: m.name || '',
    answer: (m.acceptedAnswer && (m.acceptedAnswer.text || '')) || ''
  }))

  return (
    <>
      <Seo
        title="Edicoo — Baghdad Advertising & Digital Marketing"
        description="Edicoo delivers media planning, digital advertising, influencer campaigns and production services across Baghdad and central Iraq."
        url="https://your-site.com/landings/baghdad"
        image="https://pub-cdn.sider.ai/u/U03VH4X1R0A/web-coder/68934572f1d36a2a58005e71/resource/15c08900-9eb7-4dd0-b764-47bc928699b3.jpg"
        jsonLd={[faqJsonLd, localBusinessJsonLd]}
      />

      <main className="max-w-4xl mx-auto py-20 px-4">
        <h1 className="text-4xl font-bold mb-4">Edicoo — Baghdad</h1>
        <p className="text-lg text-gray-700">
          Media planning, campaign execution and influencer programs for Baghdad-based brands.
        </p>
      </main>

      {/* Visible FAQ section (non-intrusive, matches injected JSON-LD) */}
      <FAQList items={faqItems} />
    </>
  )
}